"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaceTypeAbbrev = exports.getDirectionLetter = exports.getDirectionAbbrev = exports.EFacilityPropertyType = exports.EATSynchronizationStatus = exports.EATStreamState = exports.EATStreamServerLogSource = exports.EATStreamServerApplicationType = exports.EATStreamAccessLevel = exports.EATSpecialRoadwayType = exports.EATSignType = exports.EATSeverity = exports.EATRoadwayType = exports.EATRegion = exports.EATPushPublishStatus = exports.EATPlaceTypeAbbrev = exports.EATPlaceType = exports.EATPhoneType = exports.EATParkingType = exports.EATMapLayer = exports.EATLoggingSource = exports.EATLogStatus = exports.EATLaneType = exports.EATLaneState = exports.EATKioskSizeClass = exports.EATKioskMarkerType = exports.EATIncomingStreamType = exports.EATFerryStatus = exports.EATFacilityType = exports.EATEventType = exports.EATDirectionAbbrev = exports.EATDirection = exports.EATBeaconType = exports.EATAudience = exports.EATAmenityType = exports.EATAlignment = exports.EATAleaAlertType = void 0;
/*
* META:
* <author>Benjimin K. Aaron | Rick Webb</author>
* <created>7-8-20</created>
* <description>
*      This file exports all Enums required by Stream Creation and Management models
* </description>
*/
/*****************************************************************************
    FACILITY-RELATED ENUMS
*****************************************************************************/
var EATKioskMarkerType;
exports.EATKioskMarkerType = EATKioskMarkerType;
(function (EATKioskMarkerType) {
  EATKioskMarkerType["TrafficEvent"] = "TrafficEvent";
  EATKioskMarkerType["Facility"] = "Facility";
  EATKioskMarkerType["Camera"] = "Camera";
  EATKioskMarkerType["Unknown"] = "Unknown";
})(EATKioskMarkerType || (exports.EATKioskMarkerType = EATKioskMarkerType = {}));
var EATFacilityType;
exports.EATFacilityType = EATFacilityType;
(function (EATFacilityType) {
  EATFacilityType["WelcomeCenter"] = "WelcomeCenter";
  EATFacilityType["RestArea"] = "RestArea";
  EATFacilityType["Other"] = "Other";
})(EATFacilityType || (exports.EATFacilityType = EATFacilityType = {}));
var EATKioskSizeClass;
exports.EATKioskSizeClass = EATKioskSizeClass;
(function (EATKioskSizeClass) {
  EATKioskSizeClass["ExtraSmall"] = "ExtraSmall";
  EATKioskSizeClass["Small"] = "Small";
  EATKioskSizeClass["Medium"] = "Medium";
  EATKioskSizeClass["Large"] = "Large";
  EATKioskSizeClass["ExtraLarge"] = "ExtraLarge";
  EATKioskSizeClass["Unknown"] = "Unknown";
})(EATKioskSizeClass || (exports.EATKioskSizeClass = EATKioskSizeClass = {}));
var EFacilityPropertyType;
exports.EFacilityPropertyType = EFacilityPropertyType;
(function (EFacilityPropertyType) {
  EFacilityPropertyType[EFacilityPropertyType["parkingSpaces"] = 0] = "parkingSpaces";
  EFacilityPropertyType[EFacilityPropertyType["amenities"] = 1] = "amenities";
  EFacilityPropertyType[EFacilityPropertyType["phones"] = 2] = "phones";
  EFacilityPropertyType[EFacilityPropertyType["locations"] = 3] = "locations";
  EFacilityPropertyType[EFacilityPropertyType["mapSettings"] = 4] = "mapSettings";
  EFacilityPropertyType[EFacilityPropertyType["routesOfInterest"] = 5] = "routesOfInterest";
  EFacilityPropertyType[EFacilityPropertyType["travelTimes"] = 6] = "travelTimes";
})(EFacilityPropertyType || (exports.EFacilityPropertyType = EFacilityPropertyType = {}));
var EATAmenityType;
exports.EATAmenityType = EATAmenityType;
(function (EATAmenityType) {
  EATAmenityType["DumpStation"] = "DumpStation";
  EATAmenityType["NighttimeSecurity"] = "NighttimeSecurity";
  EATAmenityType["PicnicTable"] = "PicnicTable";
  EATAmenityType["VendingMachine"] = "VendingMachine";
  EATAmenityType["Other"] = "Other";
})(EATAmenityType || (exports.EATAmenityType = EATAmenityType = {}));
var EATParkingType;
exports.EATParkingType = EATParkingType;
(function (EATParkingType) {
  EATParkingType["Car"] = "Car";
  EATParkingType["Truck"] = "Truck";
  EATParkingType["Other"] = "Other";
})(EATParkingType || (exports.EATParkingType = EATParkingType = {}));
var EATPhoneType;
exports.EATPhoneType = EATPhoneType;
(function (EATPhoneType) {
  EATPhoneType["Day"] = "Day";
  EATPhoneType["Night"] = "Night";
  EATPhoneType["Other"] = "Other";
})(EATPhoneType || (exports.EATPhoneType = EATPhoneType = {}));
var EATAlignment;
exports.EATAlignment = EATAlignment;
(function (EATAlignment) {
  EATAlignment["Left"] = "Left";
  EATAlignment["Center"] = "Center";
  EATAlignment["Right"] = "Right";
  EATAlignment["Full"] = "Full";
  EATAlignment["None"] = "None";
})(EATAlignment || (exports.EATAlignment = EATAlignment = {}));
var EATAleaAlertType;
exports.EATAleaAlertType = EATAleaAlertType;
(function (EATAleaAlertType) {
  EATAleaAlertType["Amber"] = "AMBER";
  EATAleaAlertType["Blue"] = "Blue";
  EATAleaAlertType["MissingSenior"] = "MissingSenior";
  EATAleaAlertType["MissingChild"] = "MissingChild";
  EATAleaAlertType["MissingChildMedia"] = "MissingChildMedia";
  EATAleaAlertType["Unknown"] = "Unknown";
})(EATAleaAlertType || (exports.EATAleaAlertType = EATAleaAlertType = {}));
var EATBeaconType;
exports.EATBeaconType = EATBeaconType;
(function (EATBeaconType) {
  EATBeaconType["None"] = "None";
  EATBeaconType["TwoBeaconSyncFlash"] = "TwoBeaconSyncFlash";
  EATBeaconType["TwoBeaconOppFlash"] = "TwoBeaconOppFlash";
  EATBeaconType["FourBeaconSyncFlash"] = "FourBeaconSyncFlash";
  EATBeaconType["FourBeaconAltRowFlash"] = "FourBeaconAltRowFlash";
  EATBeaconType["FourBeaconAltColumnFlash"] = "FourBeaconAltColumnFlash";
  EATBeaconType["FourBeaconAltDiagonalFlash"] = "FourBeaconAltDiagonalFlash";
  EATBeaconType["FourBeaconNoSyncFlash"] = "FourBeaconNoSyncFlash";
  EATBeaconType["OneBeaconStrobe"] = "OneBeaconStrobe";
  EATBeaconType["TwoBeaconStrobe"] = "TwoBeaconStrobe";
  EATBeaconType["FourBeaconStrobe"] = "FourBeaconStrobe";
  EATBeaconType["Unknown"] = "Unknown";
})(EATBeaconType || (exports.EATBeaconType = EATBeaconType = {}));
var EATEventType; //represents the various regions a Wowza stream server may be serving
//one would expect the region to refer to both the server's general location and 
//the general location of Cameras feeding into the server.
exports.EATEventType = EATEventType;
(function (EATEventType) {
  EATEventType["Roadwork"] = "Roadwork";
  EATEventType["RegionalEvent"] = "RegionalEvent";
  EATEventType["Crash"] = "Crash";
  EATEventType["Incident"] = "Incident";
  EATEventType["RoadCondition"] = "RoadCondition";
  EATEventType["Facility"] = "Facility";
  EATEventType["Unknown"] = "Unknown";
})(EATEventType || (exports.EATEventType = EATEventType = {}));
var EATRegion;
exports.EATRegion = EATRegion;
(function (EATRegion) {
  EATRegion["ALDOT"] = "ALDOT";
  EATRegion["North"] = "North";
  EATRegion["WestCentral"] = "WestCentral";
  EATRegion["EastCentral"] = "EastCentral";
  EATRegion["Southwest"] = "Southwest";
  EATRegion["Southeast"] = "Southeast";
  EATRegion["Unknown"] = "Unknown";
})(EATRegion || (exports.EATRegion = EATRegion = {}));
var EATSeverity; //authorization levels for viewing a CameraDevice's associated stream
exports.EATSeverity = EATSeverity;
(function (EATSeverity) {
  EATSeverity["Closed"] = "Closed";
  EATSeverity["MajorDelay"] = "MajorDelay";
  EATSeverity["ModerateDelay"] = "ModerateDelay";
  EATSeverity["MinorDelay"] = "MinorDelay";
  EATSeverity["Uknown"] = "Unknown";
})(EATSeverity || (exports.EATSeverity = EATSeverity = {}));
var EATStreamAccessLevel; //describes what type of stream (encoding or quality) is being managed by a Wowza Server application
exports.EATStreamAccessLevel = EATStreamAccessLevel;
(function (EATStreamAccessLevel) {
  EATStreamAccessLevel["Public"] = "Public";
  EATStreamAccessLevel["Media"] = "Media";
  EATStreamAccessLevel["FirstResponder"] = "FirstResponder";
  EATStreamAccessLevel["Stakeholder"] = "Stakeholder";
  EATStreamAccessLevel["ALDOT"] = "ALDOT";
  EATStreamAccessLevel["Hidden"] = "Hidden";
  EATStreamAccessLevel["Unknown"] = "Unknown";
})(EATStreamAccessLevel || (exports.EATStreamAccessLevel = EATStreamAccessLevel = {}));
var EATStreamServerApplicationType; //describes the result of a Wowza push/publish action
exports.EATStreamServerApplicationType = EATStreamServerApplicationType;
(function (EATStreamServerApplicationType) {
  EATStreamServerApplicationType["HighDefinition"] = "HighDefinition";
  EATStreamServerApplicationType["StandardDefinition"] = "StandardDefinition";
  EATStreamServerApplicationType["HDToSDTranscode"] = "HDToSDTranscode";
  EATStreamServerApplicationType["SDToSDTranscode"] = "SDToSDTranscode";
  EATStreamServerApplicationType["Unknown"] = "Unknown";
})(EATStreamServerApplicationType || (exports.EATStreamServerApplicationType = EATStreamServerApplicationType = {}));
var EATPushPublishStatus; //identifies the type of stream
exports.EATPushPublishStatus = EATPushPublishStatus;
(function (EATPushPublishStatus) {
  EATPushPublishStatus["Active"] = "Active";
  EATPushPublishStatus["NotFound"] = "NotFound";
  EATPushPublishStatus["Error"] = "Error";
  EATPushPublishStatus["Unknown"] = "Unknown";
})(EATPushPublishStatus || (exports.EATPushPublishStatus = EATPushPublishStatus = {}));
var EATIncomingStreamType; //describes the degree of success for a Log action
exports.EATIncomingStreamType = EATIncomingStreamType;
(function (EATIncomingStreamType) {
  EATIncomingStreamType["Source"] = "Source";
  EATIncomingStreamType["Transcoder"] = "Transcoder";
})(EATIncomingStreamType || (exports.EATIncomingStreamType = EATIncomingStreamType = {}));
var EATLogStatus; // identifies the source event that led to the event action 
exports.EATLogStatus = EATLogStatus;
(function (EATLogStatus) {
  EATLogStatus["Ok"] = "Ok";
  EATLogStatus["Warning"] = "Warning";
  EATLogStatus["Error"] = "Error";
  EATLogStatus["Unknown"] = "Unknown";
})(EATLogStatus || (exports.EATLogStatus = EATLogStatus = {}));
var EATLoggingSource;
exports.EATLoggingSource = EATLoggingSource;
(function (EATLoggingSource) {
  EATLoggingSource["SourceStream"] = "SourceStream";
  EATLoggingSource["TranscodedStream"] = "TranscodedStream";
  EATLoggingSource["PushPublishEntry"] = "PushPublishEntry";
  EATLoggingSource["Unknown"] = "Unknown";
})(EATLoggingSource || (exports.EATLoggingSource = EATLoggingSource = {}));
var EATStreamServerLogSource;
exports.EATStreamServerLogSource = EATStreamServerLogSource;
(function (EATStreamServerLogSource) {
  EATStreamServerLogSource["LocalIncomingStream"] = "LocalIncomingStream";
  EATStreamServerLogSource["DistributorIncomingStream"] = "DistributorIncomingStream";
  EATStreamServerLogSource["LocalPushPublishEntry"] = "LocalPushPublishEntry";
  EATStreamServerLogSource["DistributorPushPublishEntry"] = "DistributorPushPublishEntry";
})(EATStreamServerLogSource || (exports.EATStreamServerLogSource = EATStreamServerLogSource = {}));
;
var EATDirection;
exports.EATDirection = EATDirection;
(function (EATDirection) {
  EATDirection["North"] = "North";
  EATDirection["South"] = "South";
  EATDirection["East"] = "East";
  EATDirection["West"] = "West";
  EATDirection["NorthSouth"] = "NorthSouth";
  EATDirection["EastWest"] = "EastWest";
  EATDirection["Any"] = "Any";
  EATDirection["AllDirections"] = "AllDirections";
  EATDirection["Unknown"] = "Unknown";
})(EATDirection || (exports.EATDirection = EATDirection = {}));
;

// not an api model
// created due to "EATDirection" values commonly being abbreviated in UI
var EATDirectionAbbrev;
exports.EATDirectionAbbrev = EATDirectionAbbrev;
(function (EATDirectionAbbrev) {
  EATDirectionAbbrev["North"] = "NB";
  EATDirectionAbbrev["South"] = "SB";
  EATDirectionAbbrev["East"] = "EB";
  EATDirectionAbbrev["West"] = "WB";
  EATDirectionAbbrev["NorthSouth"] = "NS";
  EATDirectionAbbrev["EastWest"] = "EW";
  EATDirectionAbbrev["Any"] = "Any";
  EATDirectionAbbrev["AllDirections"] = "All";
  EATDirectionAbbrev["Unknown"] = "N/A";
})(EATDirectionAbbrev || (exports.EATDirectionAbbrev = EATDirectionAbbrev = {}));
;
var EATLaneState;
exports.EATLaneState = EATLaneState;
(function (EATLaneState) {
  EATLaneState["Open"] = "Open";
  EATLaneState["Affected"] = "Affected";
  EATLaneState["Closed"] = "Closed";
  EATLaneState["Unknown"] = "Unknown";
})(EATLaneState || (exports.EATLaneState = EATLaneState = {}));
var EATLaneType;
exports.EATLaneType = EATLaneType;
(function (EATLaneType) {
  EATLaneType["RightExitRamp"] = "RightExitRamp";
  EATLaneType["LeftTurningLane"] = "LeftTurningLane";
  EATLaneType["RightTurningLane"] = "RightTurningLane";
  EATLaneType["ThroughLane"] = "ThroughLane";
  EATLaneType["SoftShoulder"] = "SoftShoulder";
  EATLaneType["LeftShoulder"] = "LeftShoulder";
  EATLaneType["LeftEntranceRamp"] = "LeftEntranceRamp";
  EATLaneType["LocalLanes"] = "LocalLanes";
  EATLaneType["RightShoulder"] = "RightShoulder";
  EATLaneType["LeftMergingLane"] = "LeftMergingLane";
  EATLaneType["LeftExitRamp"] = "LeftExitRamp";
  EATLaneType["Gore"] = "Gore";
  EATLaneType["RightEntranceRamp"] = "RightEntranceRamp";
  EATLaneType["RightMergingLane"] = "RightMergingLane";
  EATLaneType["Unknown"] = "Unknown";
})(EATLaneType || (exports.EATLaneType = EATLaneType = {}));
var EATAudience; // used to more declaratively convert ATDirection to DirectionAbbrev
exports.EATAudience = EATAudience;
(function (EATAudience) {
  EATAudience["Admin"] = "Admin";
  EATAudience["Dashboard"] = "Dashboard";
  EATAudience["Traffic"] = "Traffic";
  EATAudience["Video"] = "Video";
  EATAudience["None"] = "None";
})(EATAudience || (exports.EATAudience = EATAudience = {}));
var getDirectionAbbrev = function getDirectionAbbrev(direction) {
  return EATDirectionAbbrev[direction];
};

// Helper function to get direction 'letter' only
exports.getDirectionAbbrev = getDirectionAbbrev;
var getDirectionLetter = function getDirectionLetter(direction) {
  switch (direction) {
    case EATDirection.AllDirections:
      return "All";
    case EATDirection.Any:
      return "Any";
    case EATDirection.East:
      return "E";
    case EATDirection.West:
      return "W";
    case EATDirection.EastWest:
      return "E/W";
    case EATDirection.North:
      return "N";
    case EATDirection.South:
      return "S";
    case EATDirection.NorthSouth:
      return "N/S";
    case EATDirection.Unknown:
    default:
      return "UNK";
  }
};
exports.getDirectionLetter = getDirectionLetter;
var EATPlaceType;
exports.EATPlaceType = EATPlaceType;
(function (EATPlaceType) {
  EATPlaceType["Interstate"] = "Interstate";
  EATPlaceType["USHighway"] = "USHighway";
  EATPlaceType["StateHighway"] = "StateHighway";
  EATPlaceType["Arterial"] = "Arterial";
  EATPlaceType["MilePost"] = "MilePost";
  EATPlaceType["ExitRamp"] = "ExitRamp";
  EATPlaceType["CountyRoad"] = "CountyRoad";
  EATPlaceType["Unknown"] = "Unknown";
})(EATPlaceType || (exports.EATPlaceType = EATPlaceType = {}));
;

// not an api model
// created due to "EATPlaceType" values commonly being abbreviated in UI
var EATPlaceTypeAbbrev;
exports.EATPlaceTypeAbbrev = EATPlaceTypeAbbrev;
(function (EATPlaceTypeAbbrev) {
  EATPlaceTypeAbbrev["Interstate"] = "I";
  EATPlaceTypeAbbrev["USHighway"] = "US";
  EATPlaceTypeAbbrev["StateHighway"] = "ST";
  EATPlaceTypeAbbrev["Arterial"] = "A";
  EATPlaceTypeAbbrev["MilePost"] = "MP";
  EATPlaceTypeAbbrev["ExitRamp"] = "ER";
  EATPlaceTypeAbbrev["CountyRoad"] = "CR";
  EATPlaceTypeAbbrev["Unknown"] = "N/A";
})(EATPlaceTypeAbbrev || (exports.EATPlaceTypeAbbrev = EATPlaceTypeAbbrev = {}));
;

// used to more declaratively convert ATPlaceType to PlaceTypeAbbrev
var getPlaceTypeAbbrev = function getPlaceTypeAbbrev(type) {
  return EATPlaceTypeAbbrev[type];
};
exports.getPlaceTypeAbbrev = getPlaceTypeAbbrev;
var EATSynchronizationStatus;
exports.EATSynchronizationStatus = EATSynchronizationStatus;
(function (EATSynchronizationStatus) {
  EATSynchronizationStatus["Okay"] = "Okay";
  EATSynchronizationStatus["Warning"] = "Warning";
  EATSynchronizationStatus["Error"] = "Error";
  EATSynchronizationStatus["Unknown"] = "Unknown";
})(EATSynchronizationStatus || (exports.EATSynchronizationStatus = EATSynchronizationStatus = {}));
var EATSignType;
exports.EATSignType = EATSignType;
(function (EATSignType) {
  EATSignType[EATSignType["Services Guidance"] = 0] = "Services Guidance";
  EATSignType[EATSignType["Tourist Information"] = 1] = "Tourist Information";
  EATSignType[EATSignType["Evacuation Route"] = 2] = "Evacuation Route";
  EATSignType[EATSignType["Recreational Area Guidance"] = 3] = "Recreational Area Guidance";
  EATSignType[EATSignType["Cultural Interest Guidance"] = 4] = "Cultural Interest Guidance";
  EATSignType[EATSignType["Unassigned"] = 5] = "Unassigned";
  EATSignType[EATSignType["Incident Management"] = 6] = "Incident Management";
  EATSignType[EATSignType["Pedestrian Warning"] = 7] = "Pedestrian Warning";
  EATSignType[EATSignType["Bicycle Warning"] = 8] = "Bicycle Warning";
  EATSignType[EATSignType["Playground Warning"] = 9] = "Playground Warning";
  EATSignType[EATSignType["School Warning"] = 10] = "School Warning";
  EATSignType[EATSignType["Indicated Movements Permitted"] = 11] = "Indicated Movements Permitted";
  EATSignType[EATSignType["Direction Guidance"] = 12] = "Direction Guidance";
  EATSignType[EATSignType["Temporary Traffic Control"] = 13] = "Temporary Traffic Control";
  EATSignType[EATSignType["Electronic Toll Collection"] = 14] = "Electronic Toll Collection";
  EATSignType[EATSignType["Prohibition"] = 15] = "Prohibition";
  EATSignType[EATSignType["Warning"] = 16] = "Warning";
  EATSignType[EATSignType["Regulation"] = 17] = "Regulation";
})(EATSignType || (exports.EATSignType = EATSignType = {}));
;
var EATFerryStatus;
exports.EATFerryStatus = EATFerryStatus;
(function (EATFerryStatus) {
  EATFerryStatus[EATFerryStatus["Running"] = 0] = "Running";
  EATFerryStatus[EATFerryStatus["NotRunning"] = 1] = "NotRunning";
})(EATFerryStatus || (exports.EATFerryStatus = EATFerryStatus = {}));
;
var EATMapLayer;
exports.EATMapLayer = EATMapLayer;
(function (EATMapLayer) {
  EATMapLayer["Roadwork"] = "Roadwork";
  EATMapLayer["RegionalEvent"] = "RegionalEvent";
  EATMapLayer["Crash"] = "Crash";
  EATMapLayer["Incident"] = "Incident";
  EATMapLayer["Camera"] = "Camera";
  EATMapLayer["MessageSign"] = "MessageSign";
  EATMapLayer["Ferry"] = "Ferry";
  EATMapLayer["Facility"] = "Facility";
  EATMapLayer["RoadCondition"] = "RoadCondition";
  EATMapLayer["Location"] = "Location";
  EATMapLayer["Route"] = "Route";
  EATMapLayer["RouteEvent"] = "RouteEvent";
  EATMapLayer["StateTravelerInformationSystems"] = "StateTravelerInformationSystems";
  EATMapLayer["ASAPCoverage"] = "ASAPCoverage";
  EATMapLayer["Unknown"] = "Unknown";
})(EATMapLayer || (exports.EATMapLayer = EATMapLayer = {}));
var EATStreamState;
exports.EATStreamState = EATStreamState;
(function (EATStreamState) {
  EATStreamState["Active"] = "Active";
  EATStreamState["Inactive"] = "Inactive";
  EATStreamState["Unknown"] = "Unknown";
})(EATStreamState || (exports.EATStreamState = EATStreamState = {}));
var EATRoadwayType;
exports.EATRoadwayType = EATRoadwayType;
(function (EATRoadwayType) {
  EATRoadwayType["Interstate"] = "Interstate";
  EATRoadwayType["USRoute"] = "USRoute";
  EATRoadwayType["StateRoute"] = "StateRoute";
  EATRoadwayType["Unknown"] = "Unknown";
})(EATRoadwayType || (exports.EATRoadwayType = EATRoadwayType = {}));
var EATSpecialRoadwayType;
exports.EATSpecialRoadwayType = EATSpecialRoadwayType;
(function (EATSpecialRoadwayType) {
  EATSpecialRoadwayType["None"] = "None";
  EATSpecialRoadwayType["Alternate"] = "Alternate";
  EATSpecialRoadwayType["Business"] = "Business";
  EATSpecialRoadwayType["Bypass"] = "Bypass";
})(EATSpecialRoadwayType || (exports.EATSpecialRoadwayType = EATSpecialRoadwayType = {}));